import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const DueDateLegend = ({ viewType = 'list' }) => {
  return (
    <div className="mb-4 flex items-center justify-between p-3 bg-gray-800 rounded-md border border-gray-700">
      <div className="flex flex-wrap gap-4 md:gap-6">
        <div className="flex items-center">
          <div className="w-4 h-4 bg-green-500 rounded mr-2"></div>
          <span className="text-sm text-gray-300">Due in more than 7 days</span>
        </div>
        <div className="flex items-center">
          <div className="w-4 h-4 bg-orange-500 rounded mr-2"></div>
          <span className="text-sm text-gray-300">Due within 7 days</span>
        </div>
        <div className="flex items-center">
          <div className="w-4 h-4 bg-red-500 rounded mr-2"></div>
          <span className="text-sm text-gray-300">Overdue</span>
        </div>
      </div>
      
      <div className="flex items-center text-gray-400">
        <InformationCircleIcon className="h-5 w-5 mr-1" />
        <span className="text-sm">
          {viewType === 'calendar' ? 'Click on a task for details' : 'Task due date status'}
        </span>
      </div>
    </div>
  );
};

export default DueDateLegend; 